import React from 'react';
import EditableTable from 'src/views/admin/EditableTable';
import {ColumnSettings} from 'src/views/admin/EditableTable/types';
import FormikCollegeSelector from '../formik-college-selector';

const columns: ColumnSettings[] = [
  {
    name: 'collegeName',
    title: 'College Name',
    sortable: true,
    editable: false,
  },
  {
    name: 'rank',
    title: 'Rank',
    sortable: true,
    type: 'number',
  },
  {
    name: 'year',
    title: 'Year',
    sortable: true,
    type: 'number',
  },
  {
    name: 'unitId',
    title: 'College',
    sortable: true,
    FormField: FormikCollegeSelector,
    hidden: true,
  },
];

const ForbesRanks = (): React.ReactElement => (
  <div>
    <h1 className="shared-font headline">Forbes Ranks</h1>
    <EditableTable
      basePath="/v1/admin/forbes-ranks"
      defaultSortKey="collegeName"
      columns={columns}
      identifier="forbes-ranks"
      allowBulkEdit
    />
  </div>
);

export default ForbesRanks;
